<template>
    <div class="upload-document-page row justify-center items-center">
        <q-dialog v-model="importFailed">
            <q-card class="error-card">
                <q-card-section class="row items-center q-pb-none error-card-header">
                    <div class="text-h6">Importeren mislukt</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="text-subtitle1">
                        {{importFailedTitle}}
                    </div>
                </q-card-section>
                <q-card-section>
                    <div v-if="importRowsFailed">
                        <a :href="importFailedMsg" download>Download Excel-bestand met onjuiste records</a>
                    </div>
                    <div v-else class="text-italic">
                        {{importFailedMsg}}
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>
        <q-uploader label="Document uploaden"
                    color="primary"
                    :multiple="false"
                    :auto-upload="true"
                    accept=".xlsm, .xlsx, .xls"
                    :factory="factoryFn"
                    @failed="failedFn"
                    @added="addedFn" />
    </div>
</template>
<script>
    import authHeader from '../helpers/auth-header';
    import axiosUrl from '../services/axios.service';
    import router from '../router';
    import AuthService from '../services/auth.service';
    const API_URL = axiosUrl.getAxiosUrl();
    import store from '../store/index.js';
    export default {
        data() {
            return {
                importFailed: false,
                importRowsFailed: false,
                importFailedTitle: "",
                importFailedMsg: ""
            }
        },
        mounted() {
            let user = store.state.auth.user;        
            if (!user.permissions.includes("Fomo management"))
            {
                router.push('/');
            }
        },
        methods: {
            factoryFn() {
                var token = authHeader().Authorization;
                return new Promise((resolve) => {
                    resolve({
                        url: API_URL + `/import/upload`,
                        method: 'POST',
                        headers: [
                            { name: 'Authorization', value: `${token}` }
                        ]
                    })
                })
            },

            failedFn(info) {
                var responseBody = JSON.parse(info.xhr.response);               
                if (responseBody.message === "Unauthorized") {                   
                    // auto logout if "Unauthorized" response returned from api
                    AuthService.logout();
                    router.go();
                }
                else {
                   
                    var errorType = responseBody['error'];
                    var errorMsg = responseBody['errorMsg'];
                    this.importFailed = true;

                    if (errorType == 'RowsValidationFailed') {
                        this.importRowsFailed = true;
                        this.importFailedTitle = errorMsg['title'];
                        this.importFailedMsg = API_URL + `/import/download/?filePath=` + errorMsg['body'];
                    } else {
                        this.importFailedTitle = errorMsg['title'];
                        this.importFailedMsg = errorMsg['body'];
                    }
                }               
            },

            addedFn() {
                this.importFailed = false;
                this.importRowsFailed = false;
            }
        }
    }
</script>